<form>
  <spk-card title="Search Users">
    <spk-checkbox wrappedClass="pull-right" name="showInactive" [(model)]="showInactive" (modelChange)="setFilterSpecification()"></spk-checkbox>
    <spk-search-grid #grid defaultSortProperty="LastName, FirstName" list="UserSearchRow" [csvExport]="true" [leftLinks]="leftLinks" [filter]="filter"></spk-search-grid>
  </spk-card>
</form>